/* Bulletto Theme JS */
document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', function () {

  /* ── ANNOUNCEMENT BAR ─────── */
  var msgs = document.querySelectorAll('.ann-msg');
  if (msgs.length > 1) {
    var ai = 0;
    setInterval(function () {
      msgs[ai].classList.add('hidden');
      ai = (ai + 1) % msgs.length;
      msgs[ai].classList.remove('hidden');
    }, 4000);
  }

  /* ── HERO SLIDER ──────────── */
  var hero    = document.querySelector('.hero');
  var slides  = hero ? Array.from(hero.querySelectorAll('.hero__slide')) : [];
  var dots    = hero ? Array.from(hero.querySelectorAll('.hero__dot'))   : [];
  var fills   = hero ? Array.from(hero.querySelectorAll('.hero__dot-fill')) : [];
  var prevBtn = hero ? hero.querySelector('.hero__prev') : null;
  var nextBtn = hero ? hero.querySelector('.hero__next') : null;
  var current = 0;
  var ticker  = null;
  var SPEED   = 5500;

  function startFill(i) {
    var f = fills[i];
    if (!f) return;
    f.style.animation = 'none';
    f.offsetWidth;
    f.style.animation = 'fill-dot ' + SPEED + 'ms linear forwards';
  }

  function showSlide(n) {
    var prev = current;
    current = ((n % slides.length) + slides.length) % slides.length;
    slides[prev].classList.remove('active');
    dots[prev] && dots[prev].classList.remove('active');
    if (fills[prev]) fills[prev].style.animation = 'none';
    slides[current].classList.add('active');
    dots[current] && dots[current].classList.add('active');
    startFill(current);
  }

  function autoPlay() {
    clearInterval(ticker);
    if (slides.length > 1) ticker = setInterval(function () { showSlide(current + 1); }, SPEED);
  }

  if (slides.length > 1) {
    startFill(0);
    autoPlay();
    prevBtn && prevBtn.addEventListener('click', function () { showSlide(current - 1); autoPlay(); });
    nextBtn && nextBtn.addEventListener('click', function () { showSlide(current + 1); autoPlay(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { showSlide(i); autoPlay(); });
    });
    hero.addEventListener('mouseenter', function () { clearInterval(ticker); });
    hero.addEventListener('mouseleave', autoPlay);
    var tx = 0;
    hero.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      var d = tx - e.changedTouches[0].clientX;
      if (Math.abs(d) > 48) { showSlide(d > 0 ? current + 1 : current - 1); autoPlay(); }
    }, { passive: true });
  }

  /* ── SEARCH BAR ───────────── */
  var searchToggle  = document.querySelector('#search-toggle');
  var searchBar     = document.querySelector('#search-bar');
  var searchClose   = document.querySelector('#search-close');
  var searchInput   = document.querySelector('#search-input');
  var searchDefault = document.querySelector('#search-default');
  var searchLive    = document.querySelector('#search-live');
  var searchProds   = document.querySelector('#search-products');
  var searchTimer   = null;

  function openSearch() {
    searchBar.classList.add('open');
    if (searchDefault) searchDefault.style.display = 'block';
    if (searchLive)    searchLive.style.display = 'none';
    setTimeout(function () { searchInput && searchInput.focus(); }, 50);
  }

  function closeSearch() {
    searchBar.classList.remove('open');
    if (searchInput) searchInput.value = '';
    if (searchDefault) searchDefault.style.display = 'block';
    if (searchLive)    searchLive.style.display = 'none';
  }

  searchToggle && searchToggle.addEventListener('click', function () {
    searchBar.classList.contains('open') ? closeSearch() : openSearch();
  });
  var searchToggleMob = document.querySelector('#search-toggle-mob');
  searchToggleMob && searchToggleMob.addEventListener('click', function () {
    searchBar.classList.contains('open') ? closeSearch() : openSearch();
  });
  searchClose && searchClose.addEventListener('click', closeSearch);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSearch();
  });

  document.addEventListener('click', function (e) {
    if (searchBar && searchBar.classList.contains('open')) {
      var inSearch = searchBar.contains(e.target);
      var inToggle = searchToggle && searchToggle.contains(e.target);
      var inToggleMob = searchToggleMob && searchToggleMob.contains(e.target);
      if (!inSearch && !inToggle && !inToggleMob) {
        closeSearch();
      }
    }
  });

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var q = searchInput.value.trim();
      if (q.length < 2) {
        if (searchDefault) searchDefault.style.display = 'block';
        if (searchLive)    searchLive.style.display = 'none';
        return;
      }
      if (searchDefault) searchDefault.style.display = 'none';
      if (searchLive)    searchLive.style.display = 'block';
      if (searchProds)   searchProds.innerHTML = '<p class="search-loading">Searching...</p>';
      searchTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = data.resources && data.resources.results && data.resources.results.products;
            if (!products || products.length === 0) {
              searchProds.innerHTML = '<p class="search-none">No results for &ldquo;' + q + '&rdquo; — <a href="/search?q=' + encodeURIComponent(q) + '" style="color:var(--c-black);text-decoration:underline">see all results</a></p>';
              return;
            }
            var html = '<p class="search-results__label">Products</p><div class="search-product-grid">';
            products.forEach(function (p) {
              var img = '';
              if (p.image && p.image.src) {
                img = p.image.src.indexOf('//') === 0 ? 'https:' + p.image.src : p.image.src;
              } else if (p.featured_image && p.featured_image.url) {
                img = p.featured_image.url;
              }
              var price = '';
              if (p.price) {
                price = '&pound;' + parseFloat(p.price).toFixed(2);
              } else if (p.price_min) {
                price = '&pound;' + parseFloat(p.price_min).toFixed(2);
              }
              html += '<a href="' + p.url + '" class="search-product">';
              if (img) {
                html += '<div class="search-product__img"><img src="' + img + '" alt="' + p.title + '" loading="lazy"></div>';
              } else {
                html += '<div class="search-product__img" style="background:var(--c-grey-1)"></div>';
              }
              html += '<p class="search-product__name">' + p.title + '</p>';
              html += '<p class="search-product__price">' + price + '</p>';
              html += '</a>';
            });
            html += '</div>';
            html += '<div style="text-align:right;margin-top:1rem"><a href="/search?q=' + encodeURIComponent(q) + '" style="font-size:11px;font-weight:700;letter-spacing:0.1em;text-transform:uppercase;color:var(--c-grey-4)">View all results &rarr;</a></div>';
            searchProds.innerHTML = html;
          })
          .catch(function () {
            if (searchProds) searchProds.innerHTML = '<p class="search-none">Something went wrong. <a href="/search?q=' + encodeURIComponent(q) + '" style="color:var(--c-black);text-decoration:underline">Try a full search</a></p>';
          });
      }, 300);
    });
  }

  /* ── MOBILE NAV ───────────── */
  var hamburger = document.querySelector('.hamburger');
  var mobNav    = document.querySelector('.mob-nav');
  var mobBg     = mobNav && mobNav.querySelector('.mob-nav__bg');
  var mobClose  = mobNav && mobNav.querySelector('.mob-nav__close');

  function openMob()  { mobNav.classList.add('open');  document.body.style.overflow = 'hidden'; }
  function closeMob() { mobNav.classList.remove('open'); document.body.style.overflow = ''; }

  hamburger && hamburger.addEventListener('click', openMob);
  mobBg     && mobBg.addEventListener('click', closeMob);
  mobClose  && mobClose.addEventListener('click', closeMob);

  document.querySelectorAll('.mob-item__btn').forEach(function (btn) {
    if (btn.tagName === 'BUTTON') {
      btn.addEventListener('click', function () {
        var sub  = btn.nextElementSibling;
        var open = btn.classList.contains('open');
        document.querySelectorAll('.mob-item__btn').forEach(function (b) {
          b.classList.remove('open');
          var s = b.nextElementSibling;
          if (s && s.classList.contains('mob-sub')) s.classList.remove('open');
        });
        if (!open && sub) { btn.classList.add('open'); sub.classList.add('open'); }
      });
    }
  });

  /* ── CART DRAWER ──────────── */
  var cartWrap  = document.querySelector('.cart-drawer-wrap');
  var cartBg    = cartWrap && cartWrap.querySelector('.cart-drawer-wrap__bg');
  var cartClose = cartWrap && cartWrap.querySelector('.cart-drawer__close');

  function openCart()  { cartWrap.classList.add('open');  document.body.style.overflow = 'hidden'; refreshCart(); }
  function closeCart() { cartWrap.classList.remove('open'); document.body.style.overflow = ''; }

  cartBg    && cartBg.addEventListener('click', closeCart);
  cartClose && cartClose.addEventListener('click', closeCart);
  document.querySelectorAll('[data-cart]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  });

  function refreshCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  function renderCart(cart) {
    var itemsEl = cartWrap && cartWrap.querySelector('.cart-drawer__items');
    var totalEl = cartWrap && cartWrap.querySelector('.cart-drawer__total-value');
    var dotEl   = document.querySelector('.cart-dot');
    var fillEl  = cartWrap && cartWrap.querySelector('.delivery-bar__fill');
    var textEl  = cartWrap && cartWrap.querySelector('.cart-drawer__delivery-text');
    if (!itemsEl) return;
    if (dotEl) dotEl.classList.toggle('on', cart.item_count > 0);
    var pct = Math.min(100, (cart.total_price / 6000) * 100);
    if (fillEl) fillEl.style.width = pct + '%';
    if (textEl) {
  var cartTotal = cart.total_price / 100;
var threshold = 60;
var rem = Math.max(0, threshold - cartTotal);
if (rem > 0) {
  textEl.textContent = 'Spend \xA3' + rem.toFixed(2) + ' more for free delivery';
} else {
  textEl.textContent = '\uD83C\uDF89 You qualify for free delivery!';
}
    }
    if (totalEl) totalEl.textContent = '\xA3' + (cart.total_price / 100).toFixed(2);
    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="cart-empty"><p style="font-size:2rem;opacity:.12">&#128717;</p><p>Your bag is empty</p></div>';
      return;
    }

    var hasDiscount = cart.items.some(function (item) {
      return item.discounts && item.discounts.length > 0;
    });
    var discountBanner = hasDiscount
      ? '<div class="cart-discount-banner">\uD83C\uDF89 20% off applied!</div>'
      : '';

    itemsEl.innerHTML = discountBanner + cart.items.map(function (item) {
      return '<div class="cart-item">' +
        '<a href="' + item.url + '" class="cart-item__img"><img src="' + item.image + '" alt="" loading="lazy"></a>' +
        '<div>' +
          '<p class="cart-item__name">' + item.product_title + '</p>' +
          (item.properties && item.properties['Bottom Size']
            ? '<p class="cart-item__variant">Top: ' + item.variant_title + '</p>'
            : (item.variant_title !== 'Default Title' ? '<p class="cart-item__variant">' + item.variant_title + '</p>' : '')) +
          (item.properties && item.properties['Bottom Size'] ? '<p class="cart-item__variant">Bottom: ' + item.properties['Bottom Size'] + '</p>' : '') +
          '<div class="cart-item__qty">' +
            '<button data-action="dec" data-key="' + item.key + '" data-qty="' + item.quantity + '">&#8722;</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button data-action="inc" data-key="' + item.key + '" data-qty="' + item.quantity + '">+</button>' +
          '</div>' +
          '<button class="cart-item__remove" data-key="' + item.key + '">Remove</button>' +
        '</div>' +
        '<div class="cart-item__price">\xA3' + (item.final_line_price / 100).toFixed(2) + '</div>' +
      '</div>';
    }).join('');

    itemsEl.querySelectorAll('.cart-item__qty button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var qty = parseInt(btn.dataset.qty);
        var nq  = btn.dataset.action === 'dec' ? Math.max(0, qty - 1) : qty + 1;
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: btn.dataset.key, quantity: nq }) })
          .then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
      });
    });
    itemsEl.querySelectorAll('.cart-item__remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: btn.dataset.key, quantity: 0 }) })
          .then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
      });
    });
  }

  /* ── ADD TO CART → DRAWER ─── */
  document.querySelectorAll('.product-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[name="add"]');
      if (!btn || btn.disabled) return;

      var allSizeGrids = form.querySelectorAll('.size-grid');
      var missingSize = false;
      allSizeGrids.forEach(function (grid) {
        if (!grid.querySelector('.size-btn.active')) missingSize = true;
      });
      if (missingSize) {
        var msg = form.querySelector('.size-error');
        if (!msg) {
          msg = document.createElement('p');
          msg.className = 'size-error';
          msg.style.cssText = 'color:#c94040;font-size:12px;font-weight:600;margin-bottom:0.75rem;letter-spacing:0.04em';
          var atcWrap = form.querySelector('.pdp-atc');
          if (atcWrap) atcWrap.parentNode.insertBefore(msg, atcWrap);
        }
        msg.textContent = 'Please select a size before adding to your bag.';
        return;
      }

      var existingErr = form.querySelector('.size-error');
      if (existingErr) existingErr.textContent = '';

      btn.disabled = true;
      var orig = btn.textContent;
      btn.textContent = 'Adding\u2026';
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) { return r.json(); })
        .then(function (item) {
          if (typeof fbq !== 'undefined') {
            fbq('track', 'AddToCart', {
              content_ids: [String(item.product_id)],
              content_type: 'product',
              value: (item.price / 100),
              currency: 'GBP'
            });
          }
          return refreshCart();
        })
        .then(function () { openCart(); })
        .catch(function () {})
        .finally(function () { btn.disabled = false; btn.textContent = orig; });
    });
  });

  /* ── QUICK ADD ────────────── */
  document.querySelectorAll('.p-card__quick').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var card = btn.closest('.p-card');
      var link = card && card.querySelector('a[href]');
      if (link) window.location.href = link.href;
    });
  });

  /* ── PDP GALLERY ──────────── */
  var mainImg = document.querySelector('.pdp-gallery__main img');
  document.querySelectorAll('.pdp-gallery__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.dataset.src;
      if (mainImg && src) {
        mainImg.style.opacity = '0';
        setTimeout(function () {
          mainImg.src = src;
          mainImg.srcset = '';
          mainImg.style.opacity = '1';
        }, 200);
      }
      document.querySelectorAll('.pdp-gallery__thumb').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  /* ── ACCORDION ────────────── */
  document.querySelectorAll('.acc__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var body = btn.nextElementSibling;
      var open = btn.classList.contains('open');
      document.querySelectorAll('.acc__btn').forEach(function (b) {
        b.classList.remove('open');
        b.setAttribute('aria-expanded', 'false');
        if (b.nextElementSibling) b.nextElementSibling.style.maxHeight = '0';
      });
      if (!open && body) {
        btn.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
        body.style.maxHeight = body.scrollHeight + 'px';
      }
    });
  });

  /* ── SIZE BUTTONS (top and bottom, unified) ─── */
  var allVariants = (function () {
    var el = document.getElementById('product-variants');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  })();

  function updateBottomSizeAvailability(selectedTopSize) {
    var bottomBtns = document.querySelectorAll('.bottom-size-btn');
    bottomBtns.forEach(function (btn) {
      var bottomVal = btn.dataset.val;
      var available = allVariants.some(function (v) {
        return v.option1 === selectedTopSize && v.option2 === bottomVal && v.available;
      });
      if (available) {
        btn.classList.remove('out');
      } else {
        btn.classList.remove('active');
        btn.classList.add('out');
      }
    });
  }

  document.querySelectorAll('.size-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.classList.contains('out')) return;

      var grid = btn.closest('.size-grid');
      if (grid) grid.querySelectorAll('.size-btn').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');

      var form = btn.closest('.product-form');
      if (!form) return;
      var select = form.querySelector('select[name="id"]');
      if (!select) return;

      if (!btn.classList.contains('bottom-size-btn') && btn.dataset.opt === '1') {
        updateBottomSizeAvailability(btn.dataset.val);
      }

      var selectedOptions = {};
      form.querySelectorAll('.size-btn.active').forEach(function (b) {
        selectedOptions[b.dataset.opt] = b.dataset.val;
      });

      var match = null;
      for (var i = 0; i < allVariants.length; i++) {
        var v = allVariants[i];
        var matches = true;
        var keys = Object.keys(selectedOptions);
        for (var j = 0; j < keys.length; j++) {
          var optKey = 'option' + keys[j];
          if (v[optKey] !== selectedOptions[keys[j]]) { matches = false; break; }
        }
        if (matches) { match = v; break; }
      }

      var topLabel = document.getElementById('top-size-label');
      var bottomLabel = document.getElementById('bottom-size-label');
      if (topLabel && btn.dataset.opt === '1') topLabel.textContent = btn.dataset.val;
      if (bottomLabel && btn.dataset.opt === '2') bottomLabel.textContent = btn.dataset.val;

      if (match) {
        select.value = match.id;
        var atcBtn = form.querySelector('[name="add"]');
        if (atcBtn) {
          atcBtn.disabled = !match.available;
          atcBtn.textContent = match.available ? 'Add to Bag' : 'Sold Out';
        }
      }
    });
  });

  var firstActiveTop = document.querySelector('.size-btn:not(.bottom-size-btn).active');
  if (firstActiveTop && firstActiveTop.dataset.val) {
    updateBottomSizeAvailability(firstActiveTop.dataset.val);
  }

  /* ── SIZE GUIDE MODAL ─────── */
  var sgm = document.querySelector('#sgm');
  function openSGM()  { if (sgm) { sgm.classList.add('open');  document.body.style.overflow = 'hidden'; } }
  function closeSGM() { if (sgm) { sgm.classList.remove('open'); document.body.style.overflow = ''; } }
  document.querySelectorAll('.size-guide-link').forEach(function (b) { b.addEventListener('click', openSGM); });
  sgm && sgm.querySelector('.modal__bg')    && sgm.querySelector('.modal__bg').addEventListener('click', closeSGM);
  sgm && sgm.querySelector('.modal__close') && sgm.querySelector('.modal__close').addEventListener('click', closeSGM);

  /* ── STICKY ATC BAR ───────── */
  var stickyBar  = document.querySelector('.sticky-atc');
  var mainAtcBtn = document.querySelector('.pdp-atc .btn-dark');
  if (stickyBar && mainAtcBtn && window.IntersectionObserver) {
    new IntersectionObserver(function (entries) {
      stickyBar.classList.toggle('show', !entries[0].isIntersecting);
    }, { threshold: 0.1 }).observe(mainAtcBtn);
    var stickyBtn = stickyBar.querySelector('.btn-dark');
    stickyBtn && stickyBtn.addEventListener('click', function () {
      var f = document.querySelector('.product-form');
      f && f.dispatchEvent(new Event('submit', { bubbles: true }));
    });
  }

  /* ── COLLECTION SORT ──────── */
  var sortSelect = document.querySelector('.coll-toolbar__sort');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* ── CART PAGE QTY ─────────── */
  document.querySelectorAll('.cart-page .qty-ctrl button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var ctrl = btn.closest('.qty-ctrl');
      var span = ctrl && ctrl.querySelector('span');
      if (!span) return;
      var line = btn.closest('.cart-line');
      var key  = line && line.dataset.key;
      if (!key) return;
      var v  = parseInt(span.textContent) || 1;
      var nq = btn.dataset.action === 'dec' ? Math.max(0, v - 1) : v + 1;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: nq })
      }).then(function () { window.location.reload(); }).catch(function () {});
    });
  });

  /* ── META PIXEL: INITIATE CHECKOUT ─── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('#checkout-btn, .cart-page a[href="/checkout"]');
    if (btn && typeof fbq !== 'undefined') {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        fbq('track', 'InitiateCheckout', {
          value: (cart.total_price / 100),
          currency: 'GBP',
          num_items: cart.item_count
        });
      });
    }
  });

  /* ── EXIT POPUP ───────────── */
  var pop = document.querySelector('.exit-pop');
  var exitForm = document.querySelector('#exit-form');
  if (exitForm) {
    exitForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = document.querySelector('#exit-email').value;
      if (!email) return;
      var _learnq = window._learnq || [];
      _learnq.push(['identify', { '$email': email, '$consent': ['email'] }]);
      _learnq.push(['subscribe', { 'listId': 'XvZRh5', 'email': email, 'source': 'Exit Popup' }]);
      var successEl = document.querySelector('#exit-form-success');
      var btnEl     = exitForm.querySelector('.exit-pop__btn');
      var inputEl   = exitForm.querySelector('.exit-pop__input');
      if (successEl) successEl.style.display = 'block';
      if (btnEl)     btnEl.style.display = 'none';
      if (inputEl)   inputEl.style.display = 'none';
      sessionStorage.setItem('bpop', '1');
      setTimeout(closePop, 3000);
    });
  }

  var dismissed = sessionStorage.getItem('bpop');
  function showPop()  { if (!pop || dismissed) return; pop.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closePop() { if (!pop) return; pop.classList.remove('open'); document.body.style.overflow = ''; sessionStorage.setItem('bpop', '1'); }
  pop && pop.querySelector('.exit-pop__bg')    && pop.querySelector('.exit-pop__bg').addEventListener('click', closePop);
  pop && pop.querySelector('.exit-pop__close') && pop.querySelector('.exit-pop__close').addEventListener('click', closePop);
  pop && pop.querySelector('.exit-pop__skip')  && pop.querySelector('.exit-pop__skip').addEventListener('click', closePop);
  if (!dismissed) {
    var fired = false;
    document.addEventListener('mouseleave', function (e) {
      if (e.clientY < 20 && !fired) { fired = true; setTimeout(showPop, 600); }
    });
    setTimeout(function () { if (!fired) showPop(); }, 50000);
  }

  /* ── NEWSLETTER → KLAVIYO ─── */
  var nlBtn = document.querySelector('#nl-submit');
  if (nlBtn) {
    nlBtn.addEventListener('click', function () {
      var email = document.querySelector('#nl-email').value;
      if (!email || !email.includes('@')) return;
      var _learnq = window._learnq || [];
      _learnq.push(['identify', { '$email': email, '$consent': ['email'] }]);
      _learnq.push(['subscribe', { 'listId': 'XvZRh5', 'email': email, 'source': 'Newsletter Footer' }]);
      var wrap = document.querySelector('#nl-form-wrap');
      var succ = document.querySelector('#nl-success');
      if (wrap) wrap.style.display = 'none';
      if (succ) succ.style.display = 'block';
    });
  }

  /* ── QTY CONTROLS ─────────── */
  document.querySelectorAll('.qty-ctrl button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var span = btn.closest('.qty-ctrl') && btn.closest('.qty-ctrl').querySelector('span');
      if (!span) return;
      var v = parseInt(span.textContent) || 1;
      span.textContent = btn.dataset.action === 'dec' ? Math.max(1, v - 1) : v + 1;
    });
  });

  /* ── INITIAL CART DOT ─────── */
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
    var dot = document.querySelector('.cart-dot');
    if (dot) dot.classList.toggle('on', cart.item_count > 0);
  }).catch(function () {});

});